export const convertGetAttributeList = (data) =>
  data?.map((item, index) => ({
    id: item?.id,
    name: item?.name,
    attributeValueList: item?.values,
    usedByCategory: item?.totalUsedCategory,
    applyAllCategory: item?.isCommon,
    status: item?.isActive,
  }));
